import { memo } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const SelectAllListItem = ({ onClick, className, someSelected, allSelected }) => (
  <FormControlLabel
    id="selectAllLabel"
    className={className}
    onClick={onClick}
    control={
      <Checkbox
        size="small"
        style={{ fontSize: 20 }}
        indeterminate={someSelected}
        checked={allSelected}
        inputProps={{ 'aria-label': 'All' }}
      />
    }
    label="All"
  />
);

export default memo(SelectAllListItem);
